// Dashboard Events translations (en-US), loaded into dashboard.events by ./en-US.js
module.exports = {
  label: "Events",
  summary: require('./events/en-US.summary.js'),
  evolution: require('./events/en-US.evolution.js'),
  categories: require('./events/en-US.categories.js'),
};
